import {Button, Col, Container, Form, FormControl, Row, Spinner} from "react-bootstrap";

import DataTable from 'react-data-table-component';
import {useEffect, useState} from "react";
import {getDirectoryEntriesByRole, getUsers, mapDirectoryEntriesById} from "../service/UserService";
import {getLostProperties, toDateString} from "../service/JobService";

const customStyles = {
    rows: {
        style: {
            minHeight: '32px', // override the row height
        },
    }
};
export default function ReportLostProperties() {

    const [isLoading, setIsLoading] = useState(false)
    const [tableData, setTableData] = useState([])

    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [filteredData, setFilteredData] = useState([])

    const [startDate, setStartDate] = useState(() => {
        let starTempDate;
        try {
            const storedDate = localStorage.getItem('startDate');
            if (storedDate) {
                const parsedDate = parseInt(storedDate);
                if (!isNaN(parsedDate)) {
                    starTempDate = new Date(parsedDate);
                }
            }
        } catch (e) {
            console.error('Error reading start date from local storage:', e);
        }
        if (!starTempDate) {
            // Date of start of last month
            const now = new Date();
            const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            starTempDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
        }
        console.log(starTempDate);
        return starTempDate;
    });

    const [endDate, setEndDate] = useState(() => {
        let tempDate;
        try {
            const storedDate = localStorage.getItem('endDate');
            if (storedDate) {
                const parsedDate = parseInt(storedDate);
                if (!isNaN(parsedDate)) {
                    tempDate = new Date(parsedDate);
                }
            }
        } catch (e) {
            console.error('Error reading start date from local storage:', e);
        }
        if (!tempDate) {
            const now = new Date();
            tempDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        }
        return tempDate;
    });

    function stringToDate(dateString) {
        let parts = dateString.split('-');
        let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
        return mydate
    }

    const [searchText, setSearchText] = useState(() => {
        const searchText = localStorage.getItem('searchText');
        return searchText ? searchText : "";
    });

    const columns = [
        {
            name: 'Address', selector: row => row.full_address, sortable: true, maxWidth: '400px'
        }, {
            name: 'Customer Name', selector: row => row.cos_customer_name, sortable: true, width: '200px',
        }, {
            name: 'Agent Name', selector: row => row.agent_name, sortable: true, width: '200px',
        }, {
            name: 'Field Worker',
            selector: row => fieldWorkerMap[row.cos_job_worker] ? fieldWorkerMap[row.cos_job_worker] : row.cos_job_worker,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Last Job Date', selector: row => row.date, sortable: true, width: '150px',
        },
        {
            name: 'Last Job Id', selector: row => row.cos_job_id, sortable: true, width: '150px',
        }, {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            width: '150px'
        }];

    function refreshJobList(startDate, endDate) {
        setFilteredData([])
        setIsLoading(true)
        getLostProperties(startDate, endDate).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    filterTables(result, searchText)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error))
            .finally(() => {
                setIsLoading(false)
            });
    }

    function refreshFieldWorkers() {
        getUsers({roles: ['WORKER']}).then(response => {
            if (response.status === 200) {
                response.json().then(payload => {
                    const workers = getDirectoryEntriesByRole(payload, 'WORKER');
                    setFieldWorkerMap(mapDirectoryEntriesById(workers));
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        refreshFieldWorkers();
        refreshJobList(startDate, endDate);
    }, []);

    function filterTables(rawdata, searchText) {
        let tempData = rawdata
        //cos_customer_name, username, agent_name, phone, email
        if (searchText && searchText.length > 0) {
            tempData = tempData.filter(item => (item.full_address && item.full_address.toLowerCase().includes(searchText.toLowerCase()) || (item.agent_name && item.agent_name.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_customer_name && item.cos_customer_name.toLowerCase().includes(searchText.toLowerCase())) || (item.phone && item.phone.toLowerCase().includes(searchText.toLowerCase())) || (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_job_id && item.cos_job_id.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_job_worker && fieldWorkerMap[item.cos_job_worker] && fieldWorkerMap[item.cos_job_worker].toLowerCase().includes(searchText.toLowerCase()))));
        }
        setTableData(rawdata)
        setFilteredData(tempData)
    }

    function filterSearchText(value) {
        setSearchText(value)
        localStorage.setItem('searchText', value);
        filterTables(tableData, value)

    }

    function handleEndDateChange(event) {
        setEndDate(stringToDate(event.target.value))
        refreshJobList(startDate, stringToDate(event.target.value))
    }

    function handleStartDateChange(event) {
        setStartDate(stringToDate(event.target.value))
        refreshJobList(stringToDate(event.target.value), endDate)
    }

    return (<Container fluid>
            <Row>
                <Col sm={12}>
                    <Container fluid>
                        <Row className="mb-2">
                            <Col sm={2}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">
                                        <b>From:</b>
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="date"
                                            id="date-input"
                                            value={toDateString(startDate)}
                                            onChange={handleStartDateChange}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={2}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">
                                        <b>To:</b>
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="date"
                                            id="date-input"
                                            value={toDateString(endDate)}
                                            onChange={handleEndDateChange}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={5}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="12">
                                        <b>Lost Properties Report</b>
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                            <Col sm={1}><Button style={{width: "80px"}} variant="secondary" disabled={isLoading}
                                                onClick={() => refreshJobList(startDate, endDate)}>
                                {isLoading ? <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> : "Refresh"}


                            </Button></Col>
                            <Col sm={2} style={{textAlign: "right"}}>

                                <FormControl
                                    value={searchText}
                                    onChange={(e) => filterSearchText(e.target.value)}
                                    type="search"
                                    placeholder="Enter Filter Text..."
                                    className="mr-2"
                                    aria-label="Search"
                                    disabled={isLoading}
                                />
                            </Col>
                        </Row>
                        <Row>
                            {filteredData.length > 0 ? <DataTable
                                columns={columns}
                                data={filteredData}
                                customStyles={customStyles}
                                pagination
                                highlightOnHover
                                expandOnRowClicked
                            /> : <div style={{
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                            <span>No data available on Current Date Selection and Filter <br/>
                            <a href="#" onClick={() => {
                                filterSearchText("")
                            }}>Try Clear Filter</a></span>
                            </div>}
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>


    );


}
